import React, { useState } from "react";

export default function PriceSlider({ ismobile, price, setPrice }) {
  const [isHovering, setIsHovering] = useState(true);

  const getPercent = () => ((price - 10) / (2000 - 10)) * 100;

  return (
    <div className={`${ismobile} text-white mt-10 w-[90%] mx-auto`}>
      {/* Min & Max Labels */}
      <div className="flex justify-between mb-2">
        <span className="text-yellow-300 text-sm">10</span>
        <span className="text-yellow-300 text-sm">2000</span>
      </div>

      <div className="relative " onMouseEnter={() => setIsHovering(true)}>
        {/* Slider */}
        <input
          type="range"
          min={10}
          max={2000}
          step={1}
          value={price}
          onChange={(e) => setPrice(Number(e.target.value))}
          className="w-full  rounded-full  noon-slider-input"
          style={{
            cursor: "pointer",
            background: `linear-gradient(to right, #facc15 ${getPercent()}%, white ${getPercent()}%)`,
          }}
        />

        {/* Tooltip on hover */}
        {isHovering && (
          <div
            className="absolute border tool-tip-price-range text-xs px-2 py-2 rounded bg-white text-black font-medium shadow"
            style={{
              left: `calc(${getPercent()}% - 35px)`,
              transition: "left 0.1s ease",
              top: "-50px",
            }}
          >
            <img src={"/aed.png"} alt={"aed"} height={"20px"} width={"20px"} style={{ objectFit: "contain" }} className="display-inline " />
            {"  "}
            {price}
          </div>
        )}
      </div>

      {/* Display Selected Price */}
      {/* <div className="text-center mt-4 text-yellow-300 text-lg font-semibold">Selected Price: {price}</div> */}
    </div>
  );
}
